import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Empregador } from '../../api.service';
import {
  caminhoControlId,
  destinoIdFaceExterno,
  urlApiLeitor as montarUrlApiLeitor
} from './regras-url-api-leitor';

@Component({
  selector: 'app-painel-dados-empregador',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-dados-empregador.component.html',
  styleUrls: ['./painel-dados-empregador.component.css']
})
export class PainelDadosEmpregadorComponent {
  @Input({ required: true }) empregador!: Empregador;
  @Input() urlTerminal = '';

  @Output() empregadorChange = new EventEmitter<Empregador>();
  @Output() tenantChange = new EventEmitter<string>();
  @Output() carregarLogo = new EventEmitter<Event>();
  @Output() removerLogo = new EventEmitter<void>();

  emitirAlteracao() {
    this.empregadorChange.emit(this.empregador);
  }

  get urlTesteNavegador() {
    return montarUrlApiLeitor(
      this.empregador.modoApiLeitor,
      this.empregador.slugTenant,
      this.empregador.urlApiLocalLeitor
    );
  }

  get caminhoIdFace() {
    return caminhoControlId(this.empregador.slugTenant);
  }

  get destinoIdFace() {
    return destinoIdFaceExterno(this.empregador.ipApiLeitor, this.empregador.portaApiLeitor);
  }

  get modoLocal() {
    return this.empregador.modoApiLeitor === 'LOCAL';
  }

  get urlLocalEhLoopback() {
    const url = (this.empregador.urlApiLocalLeitor || '').toLowerCase();
    return this.modoLocal && (url.includes('localhost') || url.includes('127.0.0.1'));
  }
}
